import { Handle, Position } from 'reactflow';
import { Icon } from '@scale/scaleui';

type RootNodeData = {
  label: string;
  isActive: boolean;
};

export const ResumeScreenRootNode = ({ data }: { data: RootNodeData }) => {
  const { label, isActive } = data;

  return (
    <div
      className={`flex flex-col items-center justify-center bg-neutral-0 border rounded-lg min-h-[50px] min-w-[250px] max-w-[250px] ${
        isActive
          ? 'border-primary-300 shadow-md'
          : 'border-neutral-300 shadow-sm hover:border-primary-300'
      }`}
    >
      <Handle
        type="target"
        position={Position.Top}
        style={{ left: '50%', transform: 'translateX(-50%)' }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        style={{ left: '50%', transform: 'translateX(-50%)' }}
      />
      <div className="flex flex-row items-center text-xs font-semibold w-full pl-2">
        <div className="bg-primary-50 p-0.5 rounded-md">
          <Icon icon={['far', 'file-user']} size="sm" variant="primary" />
        </div>
        <div className="ml-2">{label}</div>
      </div>
    </div>
  );
};
